/**
 * @author Madhu.Sudhan Ankit.Mishra
 * @Date: 2023-04-29 13:05:06
 * @Last Modified by: ankit
 * @Last Modified time: 2024-04-29 17:50:20
 */

import React, { Fragment, PureComponent } from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { bool, func, shape, string } from 'prop-types';
import { Card, Row, Col, Form, Breadcrumb, Switch } from 'antd';

import { AppWrappperHOC } from '../Root/HOC';
import { lockUnlockWallet } from './actions';
import { fetchCardData } from '../NetworkCards/actions';
import { constants, utils } from '../../devUtils';
import Container from '../../components/Container';
import { ZaggleCard, StyledYscFlipCards, background, backgroundColour, margin, StyledIdfcFlipCards } from '../NetworkCards/StyledNetworkCard';
import { isNetworkCardLoading, select_card_data_ysc } from '../NetworkCards/selectors';
import { CALCULATE_BALANCE_YSC } from '../NetworkCards/constants';
import StyledLockUnlockWallet from './StyledWalletLockUnlock';
import { formatExpiryDate } from '../../devUtils/commonUtils';
import { selectUserDetails } from '../HeaderContainer/selectors';
import { walletLockUnlockSuccess, isWalletLockUnlockSuccess } from './selectors';

class LockUnlockWallet extends PureComponent {
  constructor(props) {
    super(props);
    this.statelesskeys = {
      defaultPayload: {},
    };
    this.handleSwitch = this.handleSwitch.bind(this);
  }

  componentDidMount() {
    const {
      match:
      { params:
        {
          id = '',
        } = {},
      } = {},
      onFetchCardData,
    } = this.props;
    onFetchCardData(id);
  }

  componentWillReceiveProps(nextProps) {
    const {
      WalletLockUnlockSuccess,
      WalletLockUnlockSuccess: {
        status = false,
      } = {},
      onFetchCardData,
      match: {
        params: {
          id = '',
        } = {},
      } = {},
    } = nextProps;
    const {
      WalletLockUnlockSuccess: _WalletLockUnlockSuccess,
    } = this.props;
    if (!utils.isEqual(WalletLockUnlockSuccess, _WalletLockUnlockSuccess) && status) {
      onFetchCardData(id);
    }
  }

  handleSwitch(value, ProductCode = '') {
    const {
      onLockUnlockWallet,
      match: {
        params: {
          id = '',
        } = {},
      } = {},
    } = this.props;
    const payload = {
      ysc_card_id: id,
      product_code: ProductCode,
      flag: value ? 'U' : 'L',
      remarks: `Please ${value ? 'Unlock' : 'Lock'}`,
    };
    onLockUnlockWallet(payload);
  }

  renderCardImages(CardDataYsc) {
    let showImage = null;
    const {
      match: {
        params: {
          id = '',
        } = {},
      } = {},
      UserDetails: {
        id: user_id = '',
      } = {},
      CardDataYsc: {
        card_info: {
          CVV = '',
          Expirydate = '',
          CardStatus = '',
          CardNumber = '',
          Network = '',
          ProductType = '',
          BankName = '',
        } = {},
      } = {},
    } = this.props;

    const cardnumber = (user_id && CardNumber && CardNumber.length) ? utils.getDecryptedData(CardNumber, user_id) : '';
    const cvv = (user_id && CVV && CVV.length) ? utils.getDecryptedData(CVV, user_id) : '';
    if (CVV) {
      showImage = (
        <Fragment>
          <input type="checkbox" id="CardClick" />
          <label className="card-containert" htmlFor="CardClick">
            <div className="card-flip">
              <div className="side default-user" >
                {BankName && BankName.toLowerCase() === 'indusind bank' ?
                  <h1><strong>Rs. {CALCULATE_BALANCE_YSC(CardDataYsc)}</strong></h1> : ''}
                {BankName && BankName.toLowerCase() === 'indusind bank' ?
                  <div className="footer">
                    <b>
                      <span>Card Number:</span> {cardnumber}<br />
                      <span>Expiry:</span> {formatExpiryDate(Expirydate)}<br />
                      <span>Card Status:</span> {CardStatus}<br />
                    </b>
                  </div> :
                  <b style={background}>
                    <h1 style={backgroundColour}><strong>Rs. {CALCULATE_BALANCE_YSC(CardDataYsc)}</strong></h1>
                    <span>Card Number:</span> {cardnumber}<br />
                    <span>Expiry:</span> {formatExpiryDate(Expirydate)}<br />
                    <span>Card Status:</span> {CardStatus}<br />
                  </b>
                }
              </div>
              <div className="side back">
                {BankName && BankName.toLowerCase() === 'indusind bank' ?
                  <h3>{cvv}</h3> : <h3 style={margin}>{cvv}</h3>}
              </div>
            </div>
          </label>
        </Fragment>
      );
    } else {
      showImage = (
        <div className="card-flip default">
          <div className={`side ${!['physical', 'virtual'].includes(id) ? 'default-user' : ''}`}>
            <h1><strong>Rs. {CALCULATE_BALANCE_YSC(CardDataYsc)}</strong></h1>
            {BankName && BankName.toLowerCase() === 'indusind bank' ?
              <div className="footer">
                <b>
                  <span>Card Number:</span> {cardnumber}<br />
                  <span>Expiry:</span> {formatExpiryDate(Expirydate)}<br />
                  <span>Card Status:</span> {CardStatus}<br />
                </b>
              </div> :
              <b style={background}>
                <h1 style={backgroundColour}><strong>Rs. {CALCULATE_BALANCE_YSC(CardDataYsc)}</strong></h1>
                <span>Card Number:</span> {cardnumber}<br />
                <span>Expiry:</span> {formatExpiryDate(Expirydate)}<br />
                <span>Card Status:</span> {CardStatus}<br />
              </b>
            }
          </div>
        </div>
      );
    }
    return (
      <Col xs={24} sm={24} md={10} lg={10} xl={10}>
        {BankName && BankName.toLowerCase() === 'indusind bank' && (
          <StyledYscFlipCards
            network={Network}
            product={ProductType}
            bankName={BankName}
          >
            {showImage}
          </StyledYscFlipCards>
        )}
        {BankName && BankName.toLowerCase() === 'idfc first bank' && (
          <StyledIdfcFlipCards bankName={BankName}>
            {showImage}
          </StyledIdfcFlipCards>
        )}
      </Col>
    );
  }

  renderLockUnlockWallets() {
    const {
      CardDataYsc: {
        card_info: {
          ProductInfo: {
            Details = [],
          } = {},
        } = {},
      } = {},
      NetworkCardLoading,
    } = this.props;
    return (
      <StyledLockUnlockWallet>
        <Row type="flex" align="middle" justify="start" gutter={[20, 20]}>
          {Details && Details.length &&
            Details.map(({ ProductCode = '', WalletName = '', WalletStatus = '' }) => (
              <div key={ProductCode}>
                <Col xs={24} sm={24} md={12} lg={12} xl={12} key={ProductCode}>
                  <Col xs={24} sm={24} md={16} lg={16} xl={16}>
                    <h3 className="nomargin-bottom margin-r-8">{WalletName || ProductCode}</h3>
                    <p
                      className={WalletStatus.toLowerCase() === 'locked' ? 'wallet-status-red font-14' : 'wallet-status-green font-14'}
                    ><div>{WalletStatus}</div>
                    </p>
                  </Col>
                  <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                    <Switch
                      className="custom-switch"
                      loading={NetworkCardLoading}
                      checked={WalletStatus && WalletStatus.toLowerCase() === 'active'}
                      onChange={(value) => this.handleSwitch(value, ProductCode)}
                    />
                  </Col>
                </Col>
              </div>
            ))
          }
        </Row>
      </StyledLockUnlockWallet>
    );
  }

  render() {
    const {
      CardDataYsc = {},
    } = this.props;
    return (
      <Fragment>
        <Container>
          <ZaggleCard>
            <Row align="middle" type="flex" gutter={24} className="margin-t-2">
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <h1>Manage Zaggle Cards</h1>
                <Breadcrumb separator="<" className="margin-b-2 font-12 custom-breadcrumb">
                  <Breadcrumb.Item href={constants.LINK_MY_PROFILE} className="crumb-link">My Account</Breadcrumb.Item>
                  <Breadcrumb.Item href={constants.LINK_PAY_BALANCE} className="crumb-link">Manage Cards</Breadcrumb.Item>
                  <Breadcrumb.Item>Wallet Lock/Unlock</Breadcrumb.Item>
                </Breadcrumb>
              </Col>
            </Row>
            <Card className="rounded noborder noshadow">
              <Row align="top" type="flex" gutter={30}>
                {this.renderCardImages(CardDataYsc)}
                <Col xs={24} sm={24} md={14} lg={14} xl={14}>
                  {this.renderLockUnlockWallets()}
                </Col>
              </Row>
            </Card>
          </ZaggleCard>
        </Container>
      </Fragment>
    );
  }
}

LockUnlockWallet.propTypes = {
  NetworkCardLoading: bool.isRequired,
  match: shape({
    params: shape({
      id: string,
      type: string,
    }),
  }).isRequired,
  CardDataYsc: shape({}).isRequired,
  UserDetails: shape({}).isRequired,
  WalletLockUnlockSuccess: shape({}).isRequired,
  onFetchCardData: func.isRequired,
  onLockUnlockWallet: func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  onFetchCardData: (payload) => dispatch(fetchCardData(payload)),
  onLockUnlockWallet: (payload) => dispatch(lockUnlockWallet(payload)),
  onLockUnlockWalletSuccess: () => dispatch(isWalletLockUnlockSuccess()),
});

const mapStateToProps = createStructuredSelector({
  CardDataYsc: select_card_data_ysc(),
  UserDetails: selectUserDetails(),
  WalletLockUnlockSuccess: walletLockUnlockSuccess(),
  NetworkCardLoading: isNetworkCardLoading(),
});

const LockUnlockWalletWrapper = Form.create({ name: 'normal_admin' })(LockUnlockWallet);
const component = connect(mapStateToProps, mapDispatchToProps)(AppWrappperHOC(LockUnlockWalletWrapper));
export { LockUnlockWallet, mapStateToProps, mapDispatchToProps, LockUnlockWalletWrapper };
export default component;



// WEBPACK FOOTER //
// client/containers/YscWalletLockUnlock/index.js